import { handleGetRequest } from "./http.service";
import { PaginationDataRes } from "types/http.type";
import {
  ApiActivityLog,
  ApiActivityLogFilters,
  TopEndpointStat,
} from "types/apiActivityLog.type";
import { PaginationParams } from "types/general.interface";

const buildQuery = (params: Record<string, string | number | undefined>) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== "") query.set(key, String(value));
  });
  return query.toString();
};

export const getApiActivityLogs = async (
  pagination: PaginationParams,
  filters: ApiActivityLogFilters
) => {
  const qs = buildQuery({ ...pagination, ...filters });
  return await handleGetRequest<PaginationDataRes<ApiActivityLog[]>>(
    `/admins/api-activity-logs?${qs}`
  );
};

export const getTopApiEndpoints = async (range: { from?: string; to?: string }) => {
  const qs = buildQuery({ ...range });
  return await handleGetRequest<TopEndpointStat[]>(
    `/admins/api-activity-logs/top-endpoints?${qs}`
  );
};
